export default __webpack_public_path__ + "static/media/logout.08f5012d.svg";